import cartDataSummaryHtml from './cartdatasummary.component.html';
import './cartdatasummary.component.scss';

class CartDataSummaryController {
    constructor($scope, CartService) {
        'ngInject';
        this.service = CartService;
        this.summary = null;
        this.items = [];
    }

    $onInit() {
        if (!this.service.loaded) {
            this.service.load().then(
                () => {
                    this.items = angular.copy(this.service.items);
                    this.summary = angular.copy(this.service.summary);
                }
            );
        }
    }
}

let cartDataSummaryComponent = {
    bindings: {},
    template: cartDataSummaryHtml,
    controller: CartDataSummaryController
}

export default cartDataSummaryComponent;